import { apiGet, apiPatch } from './client';
import type { Country, CountryBatchRequest } from '../types/Country';

export function getCountries(): Promise<Country[]> {
  return apiGet<Country[]>('/api/countries');
}

export function saveBatchCountries(
  added: Country[],
  modified: Country[],
  deletedIds: number[],
): Promise<Country[]> {
  return apiPatch<CountryBatchRequest, Country[]>(
    '/api/countries/batch',
    { added, modified, deleted: deletedIds },
  );
}
